import { convertAmountShorcut, formatAmountByLocale, getDecimalSymbol, getThousandSeparator, multiplyNumberWithExactPrecision, } from './number.utils';
/**
 * TODO: Use lib once this function have been extracted from @alk/core in order
 * to reduce the dependancy need.
 */
const flow = (fns) => (arg) => fns.reduce((acc, fn) => fn(acc), arg);
/**
 * TODO: Use lib once this function have been extracted from @alk/core in order
 * to reduce the dependancy need.
 */
const isNil = (value) => value === null || value === undefined;
export function getDecimalFloor(value, fraction) {
    const decimal = Math.pow(10, fraction);
    const truncated = Math.trunc(multiplyNumberWithExactPrecision(value, decimal));
    return truncated / decimal;
}
export function getRelevant(value, fraction) {
    const decimal = Math.pow(10, fraction);
    return Math.trunc(multiplyNumberWithExactPrecision(value, decimal)) % 100;
}
export function getTail(value, fraction, extra) {
    const decimal = Math.pow(10, fraction);
    return Math.trunc((multiplyNumberWithExactPrecision(value, decimal) * Math.pow(10, extra)) % Math.pow(10, extra));
}
/**
 * Logic calculation based on SeamlessFX Converter
 * https://scm-git-eur.misys.global.ad/projects/SFX/repos/client-ui/browse/obps/OBE/obps.Infrastructure/Converter/QuoteBoxPriceConverter.cs
 * */
export const splitRelevantAmount = (fractionSize) => (extraDigitSize) => (amount) => {
    return {
        dominate: getDecimalFloor(amount, fractionSize - 2),
        relevants: getRelevant(amount, fractionSize),
        tail: getTail(amount, fractionSize, extraDigitSize),
    };
};
const sanitizer = (checker, project, defaultValue) => (value) => {
    return checker(value) ? project(value) : defaultValue;
};
const checker = value => !isNil(value) && !Boolean(value.toString() === 'NaN');
export const sanitizeAmount = (fractionDigits = 0, omitTrailingZeros = false) => (amount) => sanitizer(checker, value => formatAmountByLocale(navigator.language)(fractionDigits)(omitTrailingZeros ? 0 : fractionDigits)(Math.round(Number(convertAmountShorcut(value.toString())) * Math.pow(10, fractionDigits)) /
    Math.pow(10, fractionDigits)), '')(amount);
export const sanitizeAbsoluteAmount = (fractionDigits = 0, omitTrailingZeros = false) => (amount) => {
    return sanitizer(checker, value => formatAmountByLocale(navigator.language)(fractionDigits)(omitTrailingZeros ? 0 : fractionDigits)(Math.round(Math.abs(Number(convertAmountShorcut(value.toString())) * Math.pow(10, fractionDigits))) / Math.pow(10, fractionDigits)), '')(amount);
};
const replace = (regexp) => (replacer = '') => (str) => str.replace(regexp, replacer);
const getRegExpFromSymbol = (symbol) => new RegExp(`[${symbol}]`, 'g');
const replaceSymbol = (symbolToReplace) => (replacer = '') => (value) => replace(getRegExpFromSymbol(symbolToReplace))(replacer)(value);
export function unSanitizeAmount(amountStr) {
    return sanitizer(checker, value => flow([
        replaceSymbol(getThousandSeparator(navigator.language))(''),
        replaceSymbol(getDecimalSymbol(navigator.language))('.'),
        Number,
    ])(value), 0)(amountStr);
}
